import { Moon, Sun } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useTheme } from '@/context';

/**
 * Compact light/dark toggle pinned to the top-right of the login
 * surface. Mirrors the toggle pattern used by `TenantMenu`: a single
 * click flips between explicit `light` and `dark` (collapsing the
 * `system` setting to whatever it currently resolves to).
 */
export function AuthThemeToggle() {
    const { theme, setTheme, resolvedTheme } = useTheme();

    const toggle = () => {
        if (theme === 'system') {
            setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
        } else {
            setTheme(theme === 'dark' ? 'light' : 'dark');
        }
    };

    const nextLabel = resolvedTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';

    return (
        <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={toggle}
            aria-label={nextLabel}
            title={nextLabel}
            className="bg-background/70 backdrop-blur-md"
        >
            {resolvedTheme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>
    );
}
